module.exports = __webpack_public_path__ + "assets/8c51b0ec43321229fe83d70b91fde6d3.png";